import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const hasBegEndWhitespace: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const value = control.value;
	if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) {
		return { hasBegEndWhitespace: true };
	}
	return null;
};
